<template>
  <div>
    <el-row>
      <el-col>
        <el-form inline :model="searchForm">
          <el-row>
            <el-form-item label="客户名称：">
              <el-input v-model="searchForm.customerName" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
            <el-form-item label="发票号码：">
              <el-input v-model="searchForm.invoiceNum" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
            <el-form-item label="发票金额：">
              <el-input v-model="searchForm.invoiceFee" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item label="发票状态：">
            <el-select filterable v-model="searchForm.invoiceStatus" style="width: 100%" :clearable="true">
              <el-option v-for="(item, index) in statusList" :key="item" :value="index + 1" :label="item">
              </el-option>
            </el-select>
          </el-form-item> -->
            <el-form-item label="发票类型：">
              <el-select size="medium" filterable v-model="searchForm.invoiceType" style="width: 100%" :clearable="true">
                <el-option v-for="(item, index) in invoiceTypeList" :key="item" :value="index + 1" :label="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-button size="medium" type="primary" @click="search">筛选</el-button>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div style="background: white; border-radius: 3px; margin-top: 20px;">
          <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
            <el-tab-pane label="未审核发票" name="1" lazy>
              <VInvoiceListTable :tableData="tableData" :otherData="otherData" @closeDialog="refresh">
              </VInvoiceListTable>
            </el-tab-pane>
            <el-tab-pane label="未开发票" name="2" lazy>
              <VInvoiceListTable :tableData="tableData" :otherData="otherData" @closeDialog="refresh">
              </VInvoiceListTable>
            </el-tab-pane>
            <el-tab-pane label="已开发票" name="3" lazy>
              <VInvoiceListTable :tableData="tableData" :otherData="otherData" @closeDialog="refresh">
              </VInvoiceListTable>
            </el-tab-pane>
            <el-tab-pane label="退票审核中" name="4" lazy>
              <VInvoiceListTable :tableData="tableData" :otherData="otherData" @closeDialog="refresh">
              </VInvoiceListTable>
            </el-tab-pane>
            <el-tab-pane label="已退票" name="5" lazy>
              <VInvoiceListTable :tableData="tableData" :otherData="otherData" @closeDialog="refresh">
              </VInvoiceListTable>
            </el-tab-pane>
            <el-tab-pane label="已拒绝发票" name="0" lazy>
              <VInvoiceListTable :tableData="tableData" :otherData="otherData" @closeDialog="refresh">
              </VInvoiceListTable>
            </el-tab-pane>
            <el-tab-pane label="全部发票" name="6" lazy>
              <VInvoiceListTable :tableData="tableData" :otherData="otherData" @closeDialog="refresh">
              </VInvoiceListTable>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination :current-page.sync="currentPage" :page-size="pageSize" :total="totalCount"
          @current-change="handleChange" layout="total,prev, pager, next, jumper">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getInvoiceList } from 'api/invoice';
import VInvoiceListTable from '../financeCenter/invoiceListTable';

export default {
  components: {
    VInvoiceListTable,
  },
  data() {
    return {
      searchForm: {},
      statusList: ['审核中', '待开票', '已开票', '退票审核中', '已退票'],
      invoiceTypeList: ['专票', '普票'],
      activeName: '1',
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10,
      currentPage: 1,
      totalCount: 0,
      tableData: [],
      otherData: { status: Number(this.activeName) },
    };
  },
  comments: {},
  created() {
    if (this.INVOICE_LIST_DATA_CONDITION.CONDITION || this.INVOICE_LIST_DATA_CONDITION.CURRENT_PAGE || this.INVOICE_LIST_DATA_CONDITION.ACTIVE_NAME) {
      this.searchForm = this.INVOICE_LIST_DATA_CONDITION.CONDITION;
      this.currentPage = this.INVOICE_LIST_DATA_CONDITION.CURRENT_PAGE;
      this.activeName = this.INVOICE_LIST_DATA_CONDITION.ACTIVE_NAME;
    } else {
      this.currentPage = 1;
    }
    this.queryInvoiceList();
  },
  computed: {
    INVOICE_LIST_DATA_CONDITION() {
      return this.$store.state.INVOICE_LIST_DATA_CONDITION;
    },
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.queryInvoiceList();
    },
    queryInvoiceList() {
      const params = {
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
      };
      if (this.searchForm.customerName) {
        params.COMPANY_NAME = this.searchForm.customerName;
      }
      if (this.searchForm.invoiceNum) {
        params.INVOICE_NUM = Number(this.searchForm.invoiceNum);
      }
      if (this.searchForm.invoiceFee) {
        params.INVOICE_FEE = Number(this.searchForm.invoiceFee);
      }
      if (this.searchForm.invoiceType) {
        params.INVOICE_TYPE = this.searchForm.invoiceType;
      }
      if ([0, 1, 2, 3, 4, 5].includes(Number(this.activeName))) {
        params.STATUS = Number(this.activeName);
      }
      getInvoiceList(params).then((res) => {
        this.tableData = [];
        this.tableData = res.LIST.map((item) => ({ ...item, INVOICE_NUM: item.INVOICE_NUM == 0 ? '' : item.INVOICE_NUM }));
        this.totalCount = res.TOTAL_COUNT;
        this.otherData = {
          ...this.otherData,
          status: Number(this.activeName),
        };
        this.$store.dispatch('SET_INVOICE_LIST_DATA_CONDITION', {
          CONDITION: this.searchForm,
          CURRENT_PAGE: this.currentPage,
          ACTIVE_NAME: this.activeName,
        });

        this.$forceUpdate();
      }).catch((err) => this.$message.show({ text: err, type: 'error' }));
    },
    handleClick() {
      sessionStorage.setItem('invoiceListActiveName', this.activeName);
      this.queryInvoiceList();
      this.otherData = { ...this.otherData, status: Number(this.activeName) };
    },
    handleChange(e) {
      this.currentPage = e;
      this.queryInvoiceList();
    },
    refresh(res) {
      if (!res) this.queryInvoiceList();
    },
  },
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/financeCenter/invoiceList.vue